/**
 * @desc 我的二维码
 */
import { EnumAPI } from '../../apis';
import { BasesController } from '../bases';
export class MyCodeController<T = any> extends BasesController<T> {
    constructor() {
        super({
            dataKey: 'id',
            infinite: true,
            pagination: EnumAPI.bffsvr_poster_list,
            paginationParams: {
                currentKey: 'curPageNo',
                pageSizeKey: 'pageSize',
                filterKey: 'search',
                response: {
                    dataSource: 'recordList',
                    total: 'recordCount'
                }
            }
        })
    }
}